import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    amountLabel: 'Amount',
    amountToBeReleasedLabel: 'Amount to be released',
    numberOfSharesLabel: 'Number of shares',
    numberOfSharesLargerThanTotalError:
      'The chosen number of shares is larger than the total number of shares',
    numberOfSharesNotIntegerError: 'The number of shares must be an integer',
    numberOfSharesNotPositiveError:
      'The number of shares must be greater than 0',
    percentOfCapitalLabel: '% of the capital',
  },
  fr: {
    amountLabel: 'Montant des parts',
    amountToBeReleasedLabel: 'Montant libéré',
    numberOfSharesLabel: 'Nombre de parts',
    numberOfSharesLargerThanTotalError:
      'Le nombre de parts renseigné est supérieur au nombre total de parts',
    numberOfSharesNotIntegerError:
      'Le nombre de parts doit être un nombre entier',
    numberOfSharesNotPositiveError:
      'Le nombre de parts doit être supérieur à 0',
    percentOfCapitalLabel: '% du capital',
  },
});
